import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { useLanguage } from "./LanguageContext";

const ContentContext = createContext({ content: null, loading: true, refresh: () => {} });

export const useContent = () => useContext(ContentContext);

export function useT() {
  const { content } = useContent();
  const { lang } = useLanguage();
  return (key) => {
    if (lang === "en" && content?.en) {
      const v = content.en[key];
      if (v !== undefined && v !== "" && !(Array.isArray(v) && v.length === 0)) return v;
    }
    return content?.[key];
  };
}

export function ContentProvider({ children }) {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/content");
      setContent(data);
    } catch (e) {
      console.error("Impossibile caricare i contenuti", e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <ContentContext.Provider value={{ content, loading, refresh: load }}>
      {children}
    </ContentContext.Provider>
  );
}
